<template>
    
    <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
    
    {{ title }}

</template>

<script setup lang="ts">

const props = defineProps({
    title: {
        type: String,
        required: true
    },
    message: {
        type: String,
        required: false
    }
});

const { title, message } = toRefs(props);

</script>

<style>
</style>
